export const Add_cart ="Add_cart";
export const Rem_cart="Rem_cart";
export const Save_address="Save_address"
export const Clear_cart="Clear_cart"
